import $ from "jquery";

// Preload the screenshots
$(document).on("turbolinks:load", function () {
  if(typeof window.preloader === "undefined") {
    return;
  }
  $("p.screenshot-links a").each(function (i, e) {
    window.preloader.addUrl($(e).attr("href"));
  });
});
